import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { useLocation } from 'react-router-dom';

/**
 * Extracts the benefits of the currently displayed URL. It also checks if the superior benefit is FLEX and then returns both FLEX
 * and inferior benefit. E.g. FLEX, LUNCH or FLEX, MOBILITY etc. If the currently displayed page has no connections to any benefits, the array will be empty.
 * @returns array of active benefits || empty array
 */
export function useBenefitsFromURL(): BenefitDTOBenefitEnum[] {
  const currentURL = useLocation();
  const subURLs = currentURL.pathname.split('/');
  const benefitSubURLs = Object.values(BenefitDTOBenefitEnum).map(benefit => benefit.toLowerCase() as Lowercase<BenefitDTOBenefitEnum>);
  return subURLs
    .filter(subUrl => benefitSubURLs.some(benefit => benefit === subUrl))
    .map(benefit => benefit.toUpperCase() as BenefitDTOBenefitEnum);
}
